/**
 * Converts a crew role name to a translation key
 * @param role - The crew role name
 * @returns The translation key for the role
 */
export function roleToTranslationKey(role: string): string {
  return `crew_role_${role.toLowerCase().replace(/\s+/g, '_')}`;
}

/**
 * Gets the translated role name
 * @param role - The crew role name
 * @param t - The translation function
 * @returns The translated role name
 */
export function getTranslatedRole(role: string, t: (key: string) => string): string {
  const translationKey = roleToTranslationKey(role);
  const translated = t(translationKey);
  
  // If the translation key doesn't exist, return the original role
  return translated === translationKey ? role : translated;
}